'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_$less$colon$less() {
}
export { $c_s_$less$colon$less as $c_s_$less$colon$less };
$p = $c_s_$less$colon$less.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
export { $h_s_$less$colon$less as $h_s_$less$colon$less };
$h_s_$less$colon$less.prototype = $p;
$p.cq = (function(x$0) {
});
